export default __webpack_public_path__ + "static/media/users.77d5f236.svg";